import { TreeView } from '@mui/lab'
import React, { useEffect, useState } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TreeItem from '@mui/lab/TreeItem';
import EmojiTransportationIcon from '@mui/icons-material/EmojiTransportation';
import { Button, IconButton, TextField, Typography } from '@mui/material';
import { ObtenerArbolActivos, ObtenerArbolActivosAsuntos } from '../../helpers/ActivosHelper';
import { Search } from '@mui/icons-material';
export const ResumenFallasPage = () => {
  const [filtroInicio, setFiltroInicio] = useState();
  const [filtroFin, setFiltroFin] = useState()
    const [activos, setActivos] = useState([]);

    const obtenerActivos =() => {
        ObtenerArbolActivosAsuntos(filtroInicio, filtroFin).then(datos=>setActivos(datos));
      }   

 
        useEffect(() => {
          //  obtenerActivos();
        }, [])

        const exportarExcel = () => {
          window.open(process.env.REACT_APP_API_URL+'/resumen.asuntos.php?inicio='+filtroInicio+'&fin='+filtroFin,'_blank');
        }
        
    const iconoNodo = () => {
        return (
        <EmojiTransportationIcon style={{fontSize:15}} />
        )
    }

    const renderTree = (nodo) =>  (
        <TreeItem  
      //    onClick={() => setActivoSeleccionado(nodo)}
          key={nodo.key} nodeId={nodo.key} label={
            <div
                style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}
            >
              <div
                style={{
                  display:'flex',
                  flexDirection:'row'
                }}
              >
                  {iconoNodo()}
                  <Typography
                      style={{fontSize:13, marginLeft:5}}
                  >
                  {nodo.title} ({nodo.asuntos} asuntos)

                  </Typography>
                </div>
                {/* <div>
                  <IconButton
                    onClick={(e) => {e.stopPropagation(); agregarActivo(nodo)}}
                  >
                    <AddCircleOutlineRounded style={{fontSize:15, color:'green'}} />
                  </IconButton>
                  <IconButton
                    onClick={(e) => {console.log('click en eliminar'); eliminarActivo(nodo.key); e.stopPropagation()}}
                  >
                  </IconButton>
                </div> */}
            </div>
        }>
          {Array.isArray(nodo.children)
?  nodo.children?.map(node => renderTree(node))
: null}
        </TreeItem>
      )

  return (
    <div
    style={{
      display:'flex',
      flexDirection:'row',
      flex:1,
      backgroundColor:'transparent',
      marginBottom:'20',
      padding:20
  //    height:'100%'
    }}
  >
  <div
  style={{
      display:'flex',
      flexDirection:'column',
      flex:1,
        color:'black',
        marginTop:10,
        marginLeft:40,
        marginRight:20,
    //    height:'100%'
    }}    
  >
    <div
      style={{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between',
        maxWidth:1024,
      }}
    >

      <span
          style={{
            fontSize:40,
            fontWeight:'bold'
          }}
          >
          Instalaciones con asuntos
      </span>
      <span
        style={{
          display:'flex',
          flexDirection:'row',
          alignItems:'center'
        }}
      >
                       <TextField
            onChange={(e) => setFiltroInicio(e.target.value)}
            value={filtroInicio}
            InputLabelProps={{shrink:true, fontSize:10 }}
            margin="dense"
            label="Desde"
            type="date"
            fullWidth
            variant="filled"
            style={{maxWidth:150,
              backgroundColor:'white',
              borderRadius:10,
              fontSize:12
            }}
            />
        <TextField
          onChange={(e) => setFiltroFin(e.target.value)}
          value={filtroFin}
          InputLabelProps={{shrink:true}}
          margin="dense"
          label="Hasta"
          type="date"
          fullWidth
          variant="filled"
            style={{maxWidth:150,
              backgroundColor:'white',
              borderRadius:10,
              marginLeft:10
            }}
          />
          <IconButton
            onClick={()=>{obtenerActivos()}}
          >
            <Search />
          </IconButton>
         <Button
         onClick={() => exportarExcel()}
          variant='contained'
          style={{
            borderRadius:10,
            backgroundColor:'#5F249F',
            textTransform:'unset'
          }}
         >
          Exportar a excel
         </Button>


      </span>
    </div>
    <div
      style={{
        display:'flex',
        flexDirection:'row',
        flex:1,
      //  height:'100%'
      }}
    >
      <div
        style={{
          display:'flex',
          flexDirection:'column',
          flex:60,
          overflowY:'auto',
          maxHeight:'80vh',
    //      minWidth:'50vw'
    //      height:'100%'
        }}
      >
        <TreeView
          aria-label="rich object"
          defaultCollapseIcon={<ExpandMoreIcon />}
          //defaultExpanded={['1']}
          //defaultExpanded={true}
          defaultExpandIcon={<ChevronRightIcon />}
          
          sx={{ height: '100%', flexGrow: 1, maxWidth: '50vw', overflowY: 'auto', backgroundColor:'white', padding:1, borderRadius:10, paddingTop:3 }}
          >
          {
            activos?.map(nodo => (
              renderTree(nodo)
              
              ))
            }
        </TreeView>
      </div>
      <div
        style={{
          display:'flex',
          flexDirection:'column',
          flex:60,
          overflowY:'auto',
          maxHeight:'80vh',
          minWidth:'50vw'
    //      height:'100%'
        }}
      >
        {/* // Aqui van los datos en caso de agregarlos */}
        </div>


      </div>
      </div>
      </div>
  )
}
